import React, { useEffect, useState } from "react";
import styles from "./BorrowerDetails.module.css";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import userPlaceHolder from "../../../assets/userplaceholder.png";
import credinLogo from "../../../assets/Credin Logo (1).svg";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import SectionOne from "./Components/SectionOne/SectionOne";
import { BorrowerContextProvider } from "./store/borrower-details";
import SectionTwo from "./Components/SectionTwo/SectionTwo";
import SectionThree from "./Components/SectionThree/SectionThree";
import axios from "axios";
import { useCallback } from "react";
import { url } from "../../../App";
import Cookies from 'js-cookie';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BorrowerDetails() {

  const [loader, setLoader] = useState(false);

  const [showSettings, setShowSettings] = useState(false);

  const [permissions, setPermissions] = useState({});

  // const [bankStatementPass, setBankStatementPass] = useState(false);

  const EMAIL = Cookies.get('Email');

  const contextMenuHandler = (e) => {
    e.preventDefault();
  };

  const Navigatee = useNavigate();

  const handleImageClick = () => {
    setShowSettings(!showSettings);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const permissionReq = {
          email: EMAIL,
          token: Cookies.get('Token'),
          useremail: EMAIL,
        };

        const { data: permissionRes } = await axios.post(url + "/user/getsingle", permissionReq);

        if (EMAIL === "rupesh.bishnoi@credin.in") {
          const permissionProxy = new Proxy({}, {
            get: function (target, prop) {
              return true
            }
          })
          setPermissions(permissionProxy)
          return
        }
        setPermissions(permissionRes[0].permission)
      } catch (err) {
        console.log(err)
      }
    }
    fetchData()
    //eslint-disable-next-line
  }, [EMAIL])

  const handleLogout = () => {
    let text = "Are you sure you want to Logout?";
    if (window.confirm(text) === true) {
      console.log("Logged Out");
      Cookies.remove('Token');
      Cookies.remove('Email');
      localStorage.clear();
      Navigatee("/");
    }
  };

  const openLoader = useCallback(() => {
    setLoader(true);
  }, []);

  const closeLoader = useCallback(() => {
    setLoader(false);
  }, []);
  return (
    <>
      {/* <ToastContainer /> */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <AppBar
        position="sticky"
        sx={{ backgroundColor: "white", color: "grey" }}
      >
        <Toolbar>
          <img src={credinLogo} style={{ height: 40, width: 150 }} alt="" />
          <div className="toolbar-div">
            <div>{Cookies.get('Email')}</div>
            <button className="navbar-drawer-btn">
              <img
                className="user-image"
                alt=""
                src={userPlaceHolder}
                onClick={handleImageClick}
              />
            </button>
            <div className={`settings ${showSettings ? "show" : ""}`}>
              <button className="navbar-dd" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <div className={styles.backgroundColor}>
        <div className={styles.containerDiv}>
          <BorrowerContextProvider>
            <SectionOne
              disableContext={contextMenuHandler}
              openLoader={openLoader}
              closeLoader={closeLoader}
              permission={permissions}
            />
            <SectionTwo
              disableContext={contextMenuHandler}
              openLoader={openLoader}
              closeLoader={closeLoader}
              permissions={permissions}
            />
            {EMAIL === "rupesh.bishnoi@credin.in" || permissions.download_loan_application_document || permissions.view_loan_application_document ? <SectionThree
              disableContext={contextMenuHandler}
              openLoader={openLoader}
              permissions={permissions}
              closeLoader={closeLoader}
            /> : ''}
          </BorrowerContextProvider>
        </div>
      </div>
    </>
  );
}
